import { useCallback, useContext, useMemo, useState } from 'react'

import { PatientIdContext } from '../../../../lib/context/patient-id'
import { fromFHIR, toFHIR } from '../../../../lib/Proxy/medications'
import { useAppDispatch } from '../../../../store'
import { MedicationsClaimsTable } from '../../../claim-history/medications-table'
import { IGAO } from '../../../igao'
import { getEntries } from '../../../shared/CrudTable/actions'

import Immunizations from './immunizations'
import { Medications } from './medications'

function MedicationsContainer (): JSX.Element {
  const dispatch = useAppDispatch()
  const [ refetchFn, setRefetchFn ] = useState<() => unknown>()
  let patientId = useContext(PatientIdContext)

  const mapFns = useMemo(() => ({
    toForm: fromFHIR,
    toFhir: (entry: any) => toFHIR(entry, patientId),
    toFhirDelete: (entry: any, formData: any) => {
      const fhirResource = toFHIR(entry, patientId)
      fhirResource.status = formData.reason

      return fhirResource
    }
  }
  ), [ patientId ])

  const medicationsUrls = useMemo(() => ({
    get: () => `/patients/${patientId ?? ''}/lists/medications`
  }), [ patientId ])

  const handleClaimsAction = useCallback((): void => {
    dispatch(
      getEntries('medication', medicationsUrls, mapFns, false)
    )
  }, [ dispatch, mapFns, medicationsUrls ])

  const handleOnMountClaimTable = useCallback((refetch: () => unknown): void => {
    setRefetchFn(() => refetch)
  }, [])

  return (
    <div className='main'>
      <Medications
        patientId={undefined}
        callbackFn={refetchFn}
        isPatientBanner={false}
      />
      <MedicationsClaimsTable
        onAction={handleClaimsAction}
        onMount={handleOnMountClaimTable}
      />
      <Immunizations />
      <IGAO path='medications' />
    </div>
  )
}

export default MedicationsContainer
